import styled from "styled-components";
import theme from "../../../style/theme";
import { RecentLocationContentByDeliveryDto } from "../../../types/delivery/delivery-dto";
import { IconTextField } from "../../text-field/IconTextField";
import { RecentLocationSearchItem } from "./RecentLocationSearchItem";

interface Props {
  searchKeyword: string;
  recentLocations: RecentLocationContentByDeliveryDto[];
  handleChangeTextField: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClickSelectButton: (
    newSelectedRecentLocation: RecentLocationContentByDeliveryDto
  ) => void;
}

const SEARCH_PLACEHOLDER = "상호명 또는 주소로 검색하세요";

export const RecentLocationSearchItemList: React.FC<Props> = ({
  searchKeyword,
  recentLocations,
  handleChangeTextField,
  handleClickSelectButton,
}) => {
  return (
    <RecentLocationItemListContainer>
      <IconTextField
        placeholder={SEARCH_PLACEHOLDER}
        name={"keyword"}
        value={searchKeyword}
        onChange={handleChangeTextField}
        width="412px"
      />

      <RecentLocationLengthContainer>
        {searchKeyword.length > 0 ? (
          <>
            {recentLocations.length > 0 ? (
              <>
                <RecentLocationLengthLeftField>
                  최신 등록순
                </RecentLocationLengthLeftField>
                <RecentLocationLengthRightField>
                  {recentLocations.length}곳
                </RecentLocationLengthRightField>
              </>
            ) : (
              <>
                <RecentLocationLengthLeftField>
                  검색 결과가 없습니다. 새로운 장소 등록은 위에서
                </RecentLocationLengthLeftField>
                <RecentLocationLengthRightField>
                  [신규 입력]
                </RecentLocationLengthRightField>
                <RecentLocationLengthLeftField>
                  을 눌러주세요
                </RecentLocationLengthLeftField>
              </>
            )}
          </>
        ) : (
          <RecentLocationLengthLeftFieldEmpty>
            최근 스케줄에서 등록한 장소를 최대 30개 불러옵니다
          </RecentLocationLengthLeftFieldEmpty>
        )}
      </RecentLocationLengthContainer>
      {recentLocations.length > 0 && (
        <RecentLocationItemListBody>
          {recentLocations.map((recentLocation) => (
            <RecentLocationSearchItem
              recentLocation={recentLocation}
              handleClickSelectButton={handleClickSelectButton}
            />
          ))}
        </RecentLocationItemListBody>
      )}
    </RecentLocationItemListContainer>
  );
};

const RecentLocationItemListContainer = styled.div`
  height: 569px;
  width: 413px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.palette.primitives.gray200};
  border-radius: 4px;
  margin-bottom: 16px;
`;

const RecentLocationLengthContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 0 12px 0;
`;

const RecentLocationLengthLeftField = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${theme.palette.primitives.black};
`;

const RecentLocationLengthLeftFieldEmpty = styled.div`
  // font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${theme.palette.primitives.gray400};
`;

const RecentLocationLengthRightField = styled.div`
  margin-left: 4px;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: ${theme.palette.primitives.black};
`;

const RecentLocationItemListBody = styled.div`
  display: flex;
  height: 482px;
  flex-direction: column;
  overflow-y: scroll;
`;
